import { useMutation, useQuery } from "@tanstack/react-query";

import useApiHelper from "../hooks/useApiHelper";
import { IAllLeadsResponse } from "../models/Lead";
import apiConfig from "../utils/apiConfig";
import { isStoredVehicle } from "../utils/vehicleDisplay";

export default function useLeadByVehicleId(componentName = "useLeadByVehicleId", vehicleId: string) {
  const { get } = useApiHelper(apiConfig(componentName));

  const lead = useQuery({
    queryKey: ["lead", componentName],
    queryFn: () => get<IAllLeadsResponse>(`/lead/partialbyvehicle?vehicleId=${vehicleId}`),
    // Vehicles that came back from a details-only registration lookup have no id, so there is
    // nothing to fetch a lead for.
    enabled: isStoredVehicle({ id: vehicleId }),
  });

  return {
    lead,
  };
}
